/* eslint-disable import/no-restricted-paths */
import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import {
	MAGAZINE_RESOURCE_ID_PARAMS,
	MAGAZINE_RESOURCE_TYPE_PARAMS,
	type MAGAZINE_RESOURCE_TYPE,
} from "@/components/pages/[hotelID]/reservationPage/magazine/edit/default/hooks/use-get-params";

type Props =
	| {
			hotelID: string;
			magazineResourceID: string;
			magazineResourceType: Exclude<MAGAZINE_RESOURCE_TYPE, "AboutHotel">;

			langCode?: LangCode;
	  }
	| {
			hotelID: string;
			magazineResourceType: Exclude<MAGAZINE_RESOURCE_TYPE, "Plan" | "Room">;
			magazineResourceID: undefined;

			langCode?: LangCode;
	  };

export function getMagazineEditPageUrl({ hotelID, magazineResourceID, magazineResourceType, langCode }: Props): string {
	const basePaths = (() => {
		if (langCode && langCode !== LangCode.Default) {
			return `${generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.I18N, { hotelID, langCode })}?${MAGAZINE_RESOURCE_TYPE_PARAMS}=${magazineResourceType}`;
		}

		return `${generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.DEFAULT, { hotelID })}?${MAGAZINE_RESOURCE_TYPE_PARAMS}=${magazineResourceType}`;
	})();

	if (magazineResourceType === "AboutHotel") {
		return basePaths;
	} else {
		return `${basePaths}&${MAGAZINE_RESOURCE_ID_PARAMS}=${magazineResourceID}`;
	}
}
